import React from 'react';
import CountUp from 'react-countup';
import './About.css';
function About(props) {
    return (
        <div>
            <div className="container-fluid">
            <img src="/img/about/adaptive.png" height="450px" width="100%"></img>
                {/* <div className="rows"> */}
                <div className="header">
                
                    {/* <h1>ABOUT</h1> */}
                </div>
                {/* </div> */}
                <div className='container'>
                    <div className='Who'>
                <div className="row">
                    <div className="col-lg-6">

                        <h2>Who We Are</h2>
                        <p>Dream Home was started in 2015, it is online platform where Architects, Civil
                            engineers, Interior Designers and Marketing Professionals from different locations have joined hands to
                            provide cost effective architectural solutions. Our foremost objective is customer relations. We focus on
                            quality through our fast response rate and premium quality. NakshaDekho.Com is planning to expand its
                            business model by working overseas.</p>

                    </div>
                    <div className="col-lg-6">
                        <div className="img">
                            <img src="/img/about/01.jpg" alt=""></img>
                        </div>
                    </div>
                </div>
                </div>
                
                </div>
                <div className='Aim'>
                <div className="row">
                    <div className='col-lg-4'>

                        <h2>OUR AIM</h2>
                        <p>Our aim is to provide best quality work with fulfilling all clients needs.
                            We understand our clients dreams and we work in the same direction. </p>

                    </div>
                    <div className='col-lg-4'>

                        <h2>Our Vision</h2>
                        <p>Our vision is to be an extraordinary Constructions firm having consistent identification for delivering high standardized qualitative construction services and to earn repeat business.</p>

                    </div>
                    <div className='col-lg-4'>

                        <h2>Our Mission</h2>
                        <p>We always work hard to achieve our customer requirements, create long-term value and gain their trust through our value-added qualitative and exceptional construction services.</p>

                    </div>
                    </div>
                </div>
                <div className='Achive' >
                    <h2>Our Achievement</h2>
                <div className="row">
                    <div className='col-lg-3'>
                        <p><CountUp end={400} /> <br></br> PROJECTS</p>
                    </div>
                    <div className='col-lg-3'>
                        <p><CountUp end={5} /><br></br>AWARDS</p>
                    </div>
                    <div className='col-lg-3'>

                        <p> 10 <br></br>EMPLOYEES</p>

                        <p><CountUp end={5} /> <br></br>EMPLOYEES</p>

                    </div>
                    <div className='col-lg-3'>
                        <p><CountUp end={500} />+ <br></br>SATISFIED CLIENTS</p>
                    </div>
                </div>
                </div>
            </div>
        </div>

    );
}

export default About;